import styled, { css } from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const cardRatioCSS = css`
	aspect-ratio: 1 / 1;

	@supports not (aspect-ratio: auto) {
		&:before {
			float: left;
			padding-top: 100%;
			content: '';
		}

		&:after {
			display: block;
			content: '';
			clear: both;
		}
	}
`;

const bannerCardRatioCSS = css`
	aspect-ratio: 1.5 / 1;
`;

export const BackgroundImage = styled.div`
	height: 100%;
	transition: transform ${theme('animation.transition')};

	> div {
		height: 100%;
	}
`;

export const NewTag = styled.div`
	background: ${palette('white')};
	border-radius: 999px;
	color: ${palette('black')};
	font-size: 10px;
	font-weight: 500;
	left: 8px;
	line-height: 1.2;
	padding: 4px 6px;
	position: absolute;
	top: 8px;
`;

export const ImageWrapper = styled.div<{ $cardSize: string; $isAvatar?: boolean }>`
	border-radius: 16px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	display: flex;
	flex-direction: column;
	overflow: hidden;
	position: relative;
	z-index: 0;
	${cardRatioCSS}
	${p => p.$cardSize === 'banner' && bannerCardRatioCSS};

	${ifProp(
		'$isAvatar',
		// A narrator's card reads as a headshot, not a cropped content thumbnail
		// (mobile's search results draw the same square photo through a
		// circular clip rather than resizing or insetting it — matched here
		// for consistency across platforms).
		css`
			border-radius: 50%;
		`,
	)}
`;

export const InfoContainer = styled.div`
	position: relative;
	margin-bottom: 16px;

	${minWidth('tablet')} {
		margin-bottom: 24px;
	}
`;

export const CardContainer = styled.a<{ isHidden: boolean }>`
	display: block;
	opacity: ${p => (p.isHidden ? 0.2 : 1)};
	pointer-events: ${p => (p.isHidden ? 'none' : 'auto')};
	margin-bottom: 1rem;
	transition: opacity 0.3s ease;

	&:hover {
		${BackgroundImage} {
			transform: scale(1.05);
		}
	}
`;
